import { Component, OnInit } from '@angular/core';
import { SimpleNotificationsComponent, NotificationComponent, PushNotificationsService, NotificationsService } from 'angular2-notifications';
import { PlatformApp } from '../../../services/app.service';
@Component({
    selector: 'app-dashboard',
    template: '<router-outlet></router-outlet>',
})
export class SimpleLayoutComponent implements OnInit {
    private notifyOptions = PlatformApp.getNotificationOptions();
    constructor(private _NotificationsService: NotificationsService, private _PushNotificationsService: PushNotificationsService) { }

    ngOnInit(): void { }

    private notify(type, title?, content?, options?) {
        if (!options) options = PlatformApp.getNotificationOptions();
        if (!options.id) options.id = type + '-' + title + '_' + content;
        switch (type) {
            case 'success': this._NotificationsService.success(title, content, options); break;
            case 'alert': this._NotificationsService.alert(title, content, options); break;
            case 'error': this._NotificationsService.error(title, content, options); break;
            case 'info': this._NotificationsService.info(title, content, options); break;
            case 'bare': this._NotificationsService.bare(title, content, options); break;
            default: this._NotificationsService.info(title, content, options);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/layout/simple-layout/simple-layout.component.ts